<template>
  <ImageWrapper
    imagePath="assets/images/Teaser_Username_Success"
    imageName="Teaser_Username_Success"
    :breakpoints="[300, 300, 353, 353, 353]"
  ></ImageWrapper>
</template>

<script setup lang="ts">
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'
</script>
